// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Domains = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Domains = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Domains = _exports.Domains = function Domains(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("g", {
      "clip-path": "url(#clip0_4685_9678)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M8.19141 10.9063C8.5801 11.4265 9.07601 11.8569 9.64549 12.1683C10.215 12.4798 10.8447 12.665 11.492 12.7114C12.1393 12.7578 12.7889 12.6643 13.3969 12.4373C14.0049 12.2102 14.5571 11.855 15.0158 11.3956L17.7311 8.67755C18.5555 7.82318 19.0116 6.67889 19.0013 5.49113C18.991 4.30338 18.5151 3.1672 17.676 2.3273C16.8369 1.4874 15.7019 1.01098 14.5153 1.00066C13.3288 0.990338 12.1856 1.44694 11.3321 2.27212L9.77533 3.82138",
      stroke: "currentColor",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M11.8101 9.09495C11.4214 8.57479 10.9255 8.14439 10.356 7.83295C9.78652 7.5215 9.15679 7.3363 8.50951 7.28989C7.86224 7.24349 7.21256 7.33698 6.60456 7.56401C5.99655 7.79104 5.44443 8.1463 4.98565 8.60571L2.27036 11.3237C1.446 12.1781 0.98986 13.3224 1.00017 14.5101C1.01048 15.6979 1.48642 16.8341 2.32548 17.674C3.16455 18.5139 4.2996 18.9903 5.48616 19.0006C6.67273 19.0109 7.81588 18.5543 8.6694 17.7291L10.2171 16.1799",
      stroke: "currentColor",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
      id: "clip0_4685_9678"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "20",
      height: "20",
      fill: "currentColor"
    }))));
  };
});
